import { useEffect, useRef } from "react";
import { ccpa } from "../../../../datasets/forms/ccpa";
import { StandardField } from "./StandardField";

export const CCPAForm = ({ data, formData, changeData, errors }) => {
  const inertRef = useRef(null);

  useEffect(() => {
    if (inertRef.current) inertRef.current.setAttribute("inert", "");
  }, []);

  return (
    <>
      <p className="ccpa-label">{ccpa.form.label}</p>
      <StandardField
        fields={data.fields.slice(0, 3)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <section className="ccpa-inputs_section">
        <StandardField
          fields={data.fields.slice(3, 7)}
          formData={formData}
          changeData={changeData}
          errors={errors}
        />
      </section>
      {/* ORC-1402 see ticket prior to changing*/}
      <section>
        <section id="standard-org_contact_ref" />
        <section ref={inertRef} className="input-main contact-field-secondary">
          <label className="input-label" htmlFor="Company Name">
            Company Name
            <span></span>
          </label>
          <input
            id="Company Name"
            name="Company Name"
            className="input-proper"
            type="email"
            tabIndex={-1}
            autoComplete="off"
            value={formData.org_contact_ref || ""}
            onChange={e => changeData(e.target.value, { id: "org_contact_ref" })}
          />
          <p className="input-error"></p>
        </section>
      </section>
      <p className="ccpa-paragraph_small">{ccpa.form.residency.header}</p>
      <section id="residency" />
      <StandardField
        fields={data.fields.slice(7, 8)}
        formData={formData}
        changeData={changeData}
        errors={errors}
      />
      <p className="ccpa-paragraph_small last">{ccpa.form.residency.footer}</p>
    </>
  );
};
